import React from 'react';
import { Button } from 'react-admin';
import { Link } from 'react-router-dom';

import ContentCreate from '@material-ui/icons/Create';
import PropTypes from 'prop-types';
import { linkToRecord } from 'ra-core';

const EditButton = ({
  query = '',
  basePath = '',
  label = 'ra.action.edit',
  record,
  icon = defaultIcon,
  createquery = (record) => ``,
  disabled = () => false,
  ...rest
}) => (
  <Button
    component={Link}
    to={
      linkToRecord(basePath, record && record.id) + query + createquery(record)
    }
    label={label}
    onClick={stopPropagation}
    {...rest}
    disabled={disabled(record)}
  >
    {icon}
  </Button>
);
const defaultIcon = <ContentCreate />;

const stopPropagation = (e) => e.stopPropagation();

EditButton.propTypes = {
  basePath: PropTypes.string,
  icon: PropTypes.element,
  label: PropTypes.string,
  record: PropTypes.any,
  query: PropTypes.string,
};

export default EditButton;
